import { DialogMessageViewModel } from '@common/model/dialog/message/dialogMessageViewModel';
import { useSelector } from 'react-redux';
import { EntityId } from '@reduxjs/toolkit';
import { DialogReducerStateShape } from './store/dialog';
import { currentDialogModel } from '.';

export const useMessageResolver = ({ id }: { id: EntityId }): DialogMessageViewModel | undefined => {
  return useSelector((state: DialogReducerStateShape) => currentDialogModel.selectors.messageSelector(state, id));
};
